import { buildApiEndpoint } from 'helpers/apiHelpers';
import { rest } from 'catering/api';
import { getCateringProductPricePreviewEndpoint } from 'catering/api/resources/cart';

export const MENU_BASE_ENDPOINT = buildApiEndpoint('/api/catering/menu');

export const getMenuByIdEndpoint = menuId => `${MENU_BASE_ENDPOINT}/${menuId}/`;
export const getMenuDetailsByIdEndpoint = menuId =>
  `${MENU_BASE_ENDPOINT}/${menuId}/details/`;
export const getMenuItemPricePreviewEndpoint = menuId =>
  buildApiEndpoint(getCateringProductPricePreviewEndpoint(menuId));

export async function getMenuById(menuId) {
  return rest.get(getMenuByIdEndpoint(menuId));
}

export async function getMenuDetailsById(menuId) {
  return await rest.get(getMenuDetailsByIdEndpoint(menuId));
}

export async function getMenuItemPricePreview(menuItemId, data) {
  return rest.post(getMenuItemPricePreviewEndpoint(menuItemId), {
    data
  });
}
